<template>
  <div>
    <PageAllow controller="Receipt" action="view" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color py-4 mx-4">
        <!-- 对账单信息 -->
        <v-expansion-panels v-model="panels" multiple accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-card-title class="ms-n4 py-0">
                <span v-if="billEntity.bill_type == 201">
                  {{ $t("ReceiptDetail.title") }}
                </span>
                <span v-if="billEntity.bill_type == 202">
                  {{ $t("ReceiptDetail.return_title") }}
                </span>
                <v-spacer />
                <v-sheet
                  class="pt-1 transparent-background-color d-inline-block"
                >
                  <v-btn
                    small
                    dark
                    color="action"
                    class="px-2 me-2 mb-1 elevation-1"
                    @click.stop="Export()"
                  >
                    <!-- <v-icon x-small class="pe-1">fa-file-export</v-icon> -->
                    {{ $t("ReceiptDetail.export") }}
                  </v-btn>
                </v-sheet>
              </v-card-title>
            </v-expansion-panel-header>
            <v-divider />

            <v-expansion-panel-content>
              <v-row no-gutters class="mt-4 table-style">
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span
                      class="secondary--text"
                      v-if="billEntity.bill_type == 201"
                    >
                      {{ $t("ReceiptDetail.Fields.bill_type_purchase_code")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span
                      class="secondary--text"
                      v-if="billEntity.bill_type == 202"
                    >
                      {{
                        $t(
                          "ReceiptDetail.Fields.bill_type_purchase_return_code"
                        )
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ billEntity.bill_code }}
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("ReceiptDetail.Fields.created")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ billEntity.created | formatTime }}
                  </v-card>
                </v-col>
                <!-- 客户名称： -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("ReceiptDetail.Fields.name",[$consts.shopName()])
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ this.accountInfo ? this.accountInfo.account_name : "" }}
                    <span v-if="billEntity.bill_type != 202">
                      {{ "(" + billEntity.by_supplier_obj + ")" }}
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" md="12">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("ReceiptDetail.Fields.bill_type")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ billEntity.bill_type_str }}
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- 活动记录 -->
          <v-expansion-panel>
            <v-expansion-panel-header class="py-0">
              <v-tabs v-model="tab" background-color="transparent">
                <v-tab
                  @click.stop="
                    tab = 0;
                    panels.find((p) => p == 1) ? null : panels.push(1);
                  "
                >
                  {{ $t("ReceiptDetail.activity.title") }}
                </v-tab>
              </v-tabs>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat>
                    <v-data-table
                      :headers="activitiesHeaders"
                      :items="activities_details"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.created="{ item }">
                        <span
                          class="text-no-wrap caption secondary--text"
                          :class="
                            $vuetify.theme.dark
                              ? 'text--lighten-1'
                              : 'text--darken-1'
                          "
                        >
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>
      <!-- 对账单明细 -->
      <div class="px-4 pb-4">
        <v-card class="px-4">
          <v-toolbar flat class="transparent-background-color">
            <v-card-title class="ms-n4 py-0">
              <span v-if="billEntity.bill_type == 201">
                {{ $t("ReceiptDetail.objectName") }}
              </span>
              <span v-if="billEntity.bill_type == 202">
                {{ $t("ReceiptDetail.return_objectName") }}
              </span>
              <v-spacer />
            </v-card-title>
          </v-toolbar>
          <v-divider />
          <v-data-table
            :headers="headers"
            :items="bill_details"
            :search="search"
            multi-sort
            disable-pagination
            hide-default-footer
            class="pb-2"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                class="transparent-background-color"
                align-self="center"
              >
                <v-row no-gutters class="me-n3">
                  <span class="caption secondary--text pt-2">
                    {{
                      $t(
                        "$vuetify.dataFooter.pageText",
                        bill_details
                          ? [
                              bill_details.length > 0 ? 1 : 0,
                              bill_details.length,
                              bill_details.length,
                            ]
                          : [0, 0, 0]
                      )
                    }}
                  </span>
                  <v-row no-gutters>
                    <v-spacer />
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="search"
                        clearable
                        :label="$t('Search.filter')"
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </v-row>
              </v-toolbar>
            </template>
            <template v-slot:footer>
                <v-row>
                  <v-spacer />
                  <v-col cols="12" sm="6" md="3">
                    <v-list-item>
                      <v-list-item-content>
                        <span class="secondary--text font-weight-bold">
                          {{ $t("ReceiptDetail.sum") }}
                        </span>
                      </v-list-item-content>
                      <v-list-item-content class="align-end text-end">
                        <span class="accent--text font-weight-bold">
                          {{ $t("Global.money")
                          }}{{ billEntity.fee | formatMoney }}
                        </span>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </template>
            <template v-slot:item.price="{ item }">
              {{ $t("Global.money") }}{{ item.price | formatMoney }}
            </template>

            <template v-slot:item.total_num="{ item }">
              {{ item.total_num ? item.total_num : 0 | formatTwoDot }}
            </template>

            <template v-slot:item.total_price="{ item }">
              {{ $t("Global.money") }}{{ item.total_price | formatMoney }}
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Receipt from "@/api/receipt";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.receipt"),
        disabled: false,
        href: "/receipt",
      },
      {
        text: i18n.t("Nav.receiptDetail"),
        disabled: false,
        href: "/receipt",
      },
      {
        text: i18n.t("Nav.receiptDetails"),
        disabled: true,
      },
    ],
    activitiesHeaders: () => [
      {
        text: i18n.t("ReceiptDetail.activity.Fields.time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("ReceiptDetail.activity.Fields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("ReceiptDetail.activity.Fields.operator"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    headers: () => [
      {
        text: i18n.t("ReceiptDetail.Fields.category_name"),
        align: "start",
        sortable: false,
        value: "category_name",
      },
      {
        text: i18n.t("ReceiptDetail.Fields.material_code"),
        align: "start",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("ReceiptDetail.Fields.material_name"),
        align: "start",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("ReceiptDetail.Fields.standards"),
        align: "start",
        sortable: false,
        value: "standard_name",
      },
      {
        text: i18n.t("ReceiptDetail.Fields.unit"),
        align: "start",
        sortable: false,
        value: "unit",
      },
      {
        text: i18n.t("ReceiptDetail.Fields.price"),
        align: "end",
        sortable: false,
        value: "price",
      },
      {
        text: i18n.t("ReceiptDetail.Fields.total_num"),
        align: "end",
        sortable: false,
        value: "total_num",
      },
      {
        text: i18n.t("ReceiptDetail.Fields.total_price"),
        align: "end",
        sortable: false,
        value: "total_price",
      },
    ],
    ...mapState(["accountInfo", "accountUser"]),
  },
  data: () => ({
    panels: [0],
    panelsDetail: [0],
    Detail: [0],
    tab: null,
    search: "",
    billEntity: {},
    activities_details: [],
    bill_details: [],
  }),
  mounted() {
    this.getReceiptDetailFromAPI();
  },
  methods: {
    getReceiptDetailFromAPI() {
      Receipt.fetchOne(this.$route.params.id, {
        order_activity: 1,
        show_order_flg: 1,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.billEntity = response.data.billEntity;
            this.activities_details = response.data.order_activities;
            this.bill_details = response.data.billEntity.bill_details;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    Export() {
      Receipt.exportOne(Object.assign(this.$route.params.id));
    },
  },
};
</script>

<style>
</style>